import Md5 from "crypto-js/md5";
import { dictTypes } from "./lynkco-constants";
const _k = (key, expireMinutes = 60 * 24 * 2) => {
  return {
    keyData: Md5(key).toString(),
    expireMinutes: expireMinutes
  };
};
export const clearWebStorageAfterLogout = () => {
  webStorage.clear(S_AUTH_TOKEN);
  webStorage.clear(S_USER);
  webStorage.clear(S_SITE_INFO);
  webStorage.clear(S_COUNTRY_LIST);
  webStorage.clear(S_PICKUP_STORE);
  webStorage.clear(S_API_ERROR);
  for (let key of Object.keys(dictTypes)) {
    webStorage.clear(S_DICTIONARY(key));
  }
  /*Clear Pdp States*/
  webStorage.clear(S_PDP_LOAN_LEADS_DATA);
  webStorage.clear(S_PDP_SUMMARY);
  webStorage.clear(S_PDP_BUNDLE);
  webStorage.clear(S_PDP_LCC);
  webStorage.clear(S_PDP_PLAN_TYPE);
  webStorage.clear(S_PDP_ORDER_SUMMARY_DICTIONARIES);
  webStorage.clear(S_PDP_PERSONAL_INFO);
  webStorage.clear(S_PDP_BILLING);
  webStorage.clear(S_PDP_DELIVERY);
  webStorage.clear(S_PDP_SHIPPING);
  webStorage.clear(S_PDP_TOUCH_POINT);
};
export const webStorage = {
  get(key) {
    if (typeof localStorage === "undefined") return null;
    const now = new Date();
    const storedData = localStorage.getItem(key.keyData);
    if (storedData !== null) {
      const dataInStore = JSON.parse(decodeURIComponent(atob(storedData)));
      if (dataInStore.updateTime) {
        if (!key.expireMinutes || now.getTime() - dataInStore.updateTime <= key.expireMinutes * 60 * 1000) {
          return dataInStore.data;
        } else {
          webStorage.clear(key);
          return null;
        }
      } else {
        webStorage.clear(key);
        return null;
      }
    } else {
      return null;
    }
  },
  getThenRemove(key) {
    const result = webStorage.get(key.keyData);
    webStorage.clear(key);
    return result;
  },
  set(key, data) {
    if (typeof localStorage === "undefined") return;
    const now = new Date();
    const dataInStore = {
      data,
      updateTime: now.getTime()
    };
    const storedData = btoa(encodeURIComponent(JSON.stringify(dataInStore)));
    localStorage.setItem(key.keyData, storedData);
  },
  clear(key) {
    if (typeof localStorage === "undefined") return;
    localStorage.removeItem(key.keyData);
  },
  addCartItem(key, id) {
    if (typeof localStorage === "undefined") return;
    // id = {
    //   skuAttributeValueMap: { color: "red", size: "M" },
    //   spuId: 246,
    //   skuId: 1261
    // };
    let items = localStorage.getItem(key.keyData);
    items = items ? JSON.parse(decodeURIComponent(atob(items))) : [];
    let cartItems = [];
    if (items && items.length > 0) {
      cartItems = items;
    }
    cartItems.push(id);
    localStorage.setItem(key.keyData, btoa(encodeURIComponent(JSON.stringify(cartItems))));
  },
  removeCartItem(key, id) {
    if (typeof localStorage === "undefined") return;
    let items = JSON.parse(decodeURIComponent(atob(localStorage.getItem(key.keyData))));
    if (!id.skuAttributeValueMap) {
      items = items.filter(element => element.spuId !== id.spuId && element.skuId !== id.skuId);
    } else {
      var index = items.findIndex(element => element.skuId === id.skuId && element.spuId === id.spuId);
      if (index > -1) {
        items.splice(index, 1);
      }
    }

    localStorage.setItem(key.keyData, btoa(encodeURIComponent(JSON.stringify(items))));
  },
  getCartItems(key) {
    if (typeof localStorage === "undefined") return;
    const storedData = localStorage.getItem(key.keyData);
    if (storedData !== null) {
      return JSON.parse(decodeURIComponent(atob(storedData)));
    } else {
      return null;
    }
  }
};
export const S_AUTH_TOKEN = _k("auth-token", null);
export const S_USER = _k("user-info", null);
export const S_SITE_INFO = _k("site-info", 2);
export const S_BECOME_A_MEMBER_SUMMARY = _k("become-a-member-summary");
export const S_SKU = _k("sku");
export const S_ORDER_ID = _k("order-id");
export const S_ORDER_NO = _k("order-no");
export const S_CART_ITEMS = _k("cart-items");
export const S_DELIVERY = _k("delivery-info");
export const S_MEMBER_TYPE = _k("gears-member-type");
export const S_BILLING_INFO = _k("gears-billing-info");
export const S_SHIPPING_INFO = _k("gears-shipping-info");
export const S_CONTACT_INFO = _k("gears-contact-info");
export const S_DIFF_ADDR = _k("gears-diff-addr");
export const S_LANG = _k("lang");
export const S_COUNTRY_LIST = _k("country-list", 5);
export const S_SITE_COUNTRY_LIST = _k("site-country-list", 5);
export const S_SESSION_ID = _k("sessionId");
export const S_MARKET = _k("market");
export const S_MEMBERCREATE_CONTRACTID = _k("member-create-contractid");
export const S_DICTIONARY = key => _k(`dictionary-${key}`, 5);
export const S_API_ERROR = _k("api-error", 5);
export const S_STORE = _k("selected-store");
export const S_STAFF_INFO = _k("staff-info");
export const S_PICKUP_STORE = _k("pickup-store");
export const S_EDITING_CARD = _k("editing-card");
export const S_GEAR_SAVE_PAYMENT = _k("gear-save-payment");

export const S_PDP_ORDER_SUMMARY_DICTIONARIES = _k("pdp-order-summary-dictionaries", 5);
export const S_PDP_DELIVERY = _k("pdp-delivery");
export const S_PDP_MARKET = _k("pdp-market");
export const S_PDP_SUMMARY = _k("pdp-summary");
export const S_PDP_LOAN_LEADS_DATA = _k("pdp-loan-leads-data");
export const S_PDP_SHIPPING = _k("pdp-shipping");
export const S_PDP_BILLING = _k("pdp-billing");
export const S_PDP_PERSONAL_INFO = _k("pdp-peronsal-info");
export const S_PDP_TOUCH_POINT = _k("pdp-touch-point");
export const S_PDP_BUNDLE = _k("pdp-bundle");
export const S_PDP_LCC = _k("pdp-lcc");
export const S_PDP_PLAN_TYPE = _k("pdp-plan-type");
export const S_ID_NUMBER_RULE_LIST = _k("id-number-rule-list", 5);
export const S_MARKET_LIST = _k("market-list", 5);
export const S_PDP_LOAN_ORDER_STATUS = _k("pdp-loan-order-status");
export const S_PDP_RISK_CHECK = _k("pdp-risk-check");

export const S_SITE_MODALS = _k("site-modals", 2);
export const S_GENDER = _k("gender", 1);
export const S_COMMENTS_COUNTRIES = _k("comments-country", 2);

export const S_PRIVACY_ID = _k("PrivacyId");
export const S_COOKIE_VERSION = _k("CookieVersion");